import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=06d4ba16&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupDetail.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d4ba16",
  null
  
)

export default component.exports